const hostApi =
  process.env.NODE_ENV === 'development'
    ? 'https://us-central1-starchaser-dev.cloudfunctions.net/api'
    : 'https://us-central1-starchaser-70856.cloudfunctions.net/api';
const portApi = '';
const baseURLApi =
  process.env.NODE_ENV === 'development'
    ? 'https://us-central1-starchaser-dev.cloudfunctions.net/api'
    : 'https://us-central1-starchaser-70856.cloudfunctions.net/api';

//TO CHANGE
//CORRECT
const authURLApi = 'https://starchaser.cloud.servier.com/api';
//DEV
// const authURLApi = 'http://localhost:8091/api';

// const authURLApi = process.env.NODE_ENV === 'development' ? 'http://localhost:8091/api' : 'http://localhost:8091/api';
// const authURLApi = process.env.NODE_ENV === "development" ? "https://20.40.136.214:8080/api"
//   : "https://20.40.136.214:8080/api";
const StarchaserClientID = 'a5b5de39-592e-415c-8161-21c109c47f25';

export default {
  hostApi,
  portApi,
  baseURLApi,
  authURLApi,
  StarchaserClientID,
  remote: '',
  isBackend: process.env.VUE_APP_BACKEND,
  auth: {
    // email: 'admin@flatlogic.com',
    // password: 'password'
  }
};
